var map = {
	"./async-dark.webp": "fjK9",
	"./async.webp": "QhRY",
	"./avatar/ajoy-anand.webp": "DNa2",
	"./avatar/rakesh-soni.webp": "iHsD",
	"./consumer-digital-identity-trends-2023.webp": "DBmt",
	"./consumer-identity-trend--.webp": "EhuZ",
	"./consumer-identity-trend.webp": "rGor",
	"./facebook.webp": "BA6Y",
	"./feedly.webp": "RsCh",
	"./fuel.webp": "B3+j",
	"./hacktober-fest-banner.webp": "zsQ+",
	"./hacktober-fest-cover-image.webp": "qoUr",
	"./icon-close.webp": "KvP1",
	"./iconHamburger.webp": "9I1m",
	"./left-arrow.webp": "dn3n",
	"./linkedin.webp": "2bMU",
	"./logo-blog.webp": "yi2Z",
	"./logo.webp": "aYFk",
	"./lr-logo-adj.webp": "dpee",
	"./lr-logo-blog-text.webp": "BJeU",
	"./open-source.webp": "lv/U",
	"./right-arrow.webp": "E2w3",
	"./start-with-identity.webp": "Su0y",
	"./swi.webp": "ozlS",
	"./twitter.webp": "2LFV",
	"./webinar-banner.webp": "tubL",
	"./write-for-us.webp": "rwVi",
	"./youtube.webp": "Sq3T"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PH7M";